module.exports = __webpack_public_path__ + "img/let-that-shit-go_B09NR5R6ZH.1410c9e7.jpg";